module.exports = __webpack_public_path__ + "static/wild-16c63052e8d8fe199d5530c1ef87d5a3.jpg";